export default class MicrosoftConfigurationDto
{
    public key: string|null = null;
    public consent = true;
    public enhanced = false;
    public enableAutoSpaTracking = true;
    public debug = false;
}